import React from 'react';

const NoteIcon: React.FC = () => (
  <svg
    width='32'
    height='32'
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M19.844 18.676L20 18.6667H28V5.332C28 4.596 27.4067 4 26.676 4H5.324C4.59333 4 4 4.59333 4 5.324V26.676C4.00106 27.028 4.14181 27.3651 4.39132 27.6134C4.64083 27.8617 4.97869 28.0007 5.33067 28H18.6667V20L18.676 19.844C18.7111 19.5464 18.8454 19.2693 19.0573 19.0573C19.2693 18.8454 19.5464 18.7111 19.844 18.676Z'
      fill='url(#paint0_linear_8328_60402)'
    />
    <path d='M28 21.3333L21.3333 27.996V21.3333H28Z' fill='white' />
    <defs>
      <linearGradient
        id='paint0_linear_8328_60402'
        x1='16'
        y1='4'
        x2='16'
        y2='28'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#C7C6CF' />
        <stop offset='1' stopColor='#656469' />
      </linearGradient>
    </defs>
  </svg>
);

export default NoteIcon;
